/* 🤖 this file was generated by script */
export const wiconDocumentSuccess = {
  name: 'document_success',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 8.5V17H5V3h3"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10 5.02l1.85 1.86L15.73 3m-8.7 9.03H13M7 10h2.5M7 14.07h6"/></svg>`,
};
